import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { TableData } from 'src/app/shared/models/tableData';
import { JobPointeSettingsService } from 'src/app/service/job-pointe-settings/job-pointe-settings.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-manage-owner-list',
  templateUrl: './manage-owner-list.component.html',
  styleUrls: ['./manage-owner-list.component.scss'],
})
export class ManageOwnerListComponent implements OnInit {
  constructor(
    private jobPointeSettingsService: JobPointeSettingsService,
    public renderer2: Renderer2,
    private loaderService: LoaderService,
  ) {}
  @Input() job: any;

  ngOnInit(): void {}

  private modalIsOpenSource = new BehaviorSubject<boolean>(false);
  modalIsOpen = this.modalIsOpenSource.asObservable();

  modelDetail: any = {
    'asset-classes': {},
    categories: {},
    manufacturers: {},
    enabled: {},
  };

  data: TableData = {
    label: 'Manage Foreman',
    type: 'manageForeman',
    editAccess: true,
    selectable: false,
    statusToggle: false,
    columns: [
      {
        name: 'name',
        label: 'Foreman',
        property: row => `${row?.firstName}`,
        sortable: true,
        component: 'employee-profile',
        columnStyles: { 'max-width': '200px' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'unionLocal',
        label: 'Contact Info',
        property: row => row?.employeeUnionLocal?.name,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '3rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'isOnJobBoard',
        label: '',
        property: row => row?.city,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'text-align': '-webkit-center' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'currentAssignment',
        label: 'Job',
        component: 'job-count',
        property: row => row?.city,
        sortable: true,
        columnStyles: {
          'min-width': '100px',
          'max-width': '8%',
          'white-space': 'inherit',
        },
        headerStyles: { 'min-width': '8rem' },
        columnClasses: { 'text-truncate': true },
      },
    ],
    rowActions: [],
    data: [],
    pagination: {},
    meta: {},
  };

  loadOptions(key: string): void {
    this.jobPointeSettingsService.read[key]().subscribe(
      res => {
        this.loaderService.hideLoader();
        const settings = res.data.reduce((list, item) => {
          list[item.id] = item.name;
          return list;
        }, {});
        this.modelDetail[key] = settings;
      },
      error => {
        console.error(error);
        this.loaderService.hideLoader();
      },
    );
  }

  ngAfterViewInit(): void {
    this.loadSelect2();
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
  }
}
